<template>
<svg xmlns="http://www.w3.org/2000/svg" hidden aria-hidden="true" class="icon-sprite">
    <symbol id="i-home" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z"/>
    </symbol>
    <symbol id="i-calendar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3.5" y="5" width="17" height="15.5" rx="2"/>
      <path d="M8 3.5v3M16 3.5v3M3.5 10h17"/>
    </symbol>
    <symbol id="i-chart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 19h16M7 16V9M12 16V5M17 16v-4"/>
    </symbol>
    <symbol id="i-card" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="6" width="18" height="12" rx="2"/>
      <path d="M3 10h18M7 14h3"/>
    </symbol>
    <symbol id="i-message" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M20 11.5a7.5 7.5 0 0 1-7.5 7.5H8l-4 2v-5a7.5 7.5 0 1 1 16-4.5Z"/>
      <path d="M8 10h8M8 13h5"/>
    </symbol>
    <symbol id="i-bell" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M6 16.5V10a6 6 0 1 1 12 0v6.5l1.2 1.8H4.8L6 16.5Z"/>
      <path d="M10 19.5a2 2 0 0 0 4 0"/>
    </symbol>
    <symbol id="i-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="8.25"/>
      <path d="m8.5 12.2 2.4 2.4 4.6-5"/>
    </symbol>
    <symbol id="i-user" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="8.5" r="3.25"/>
      <path d="M5.5 19.5a6.5 6.5 0 0 1 13 0"/>
    </symbol>
    <symbol id="i-support" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="8.25"/>
      <path d="M12 16.5v.5M9.2 9.4a2.8 2.8 0 1 1 3.5 3.5c-.7.5-1.2 1-1.2 1.9"/>
    </symbol>
    <symbol id="i-video" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="7" width="12.5" height="10" rx="2"/>
      <path d="m15.5 11 5-2.5v7L15.5 13"/>
    </symbol>
    <symbol id="i-clock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="8.25"/>
      <path d="M12 8v4.5l3 1.5"/>
    </symbol>
    <symbol id="i-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M15 6 9 12l6 6"/>
    </symbol>
    <symbol id="i-shield" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 3.5 19 7v5.2c0 4.2-2.9 7.2-7 8.8-4.1-1.6-7-4.6-7-8.8V7l7-3.5Z"/>
    </symbol>
    <symbol id="i-path" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 17c3-1 5-5 8-5s5 4 8 5"/>
      <circle cx="5" cy="16.5" r="1.6" fill="currentColor" stroke="none"/>
      <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/>
      <circle cx="19" cy="16.5" r="1.6" fill="currentColor" stroke="none"/>
    </symbol>
  </svg>
</template>
<script>
export default { name: 'PortalSprite' }
</script>
